import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import HorizontalFormInput from "../common/horizontal-form-inputs/HorizontalFormInput";
import FormModal from "../common/modals/FormModal";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const EditNoteModal = ({showModal, onClose, note}) => {
    const mutation = graphql`
    mutation EditNoteModalMutation($noteId: ID!, $content: String!) {
        modifyNote(input: {noteId: $noteId, content: $content}) {
            note {
                id
                parent {
                    ... on Organization {
                        notes {
                            ...Notes
                        }}
                    ... on LegalContract {
                        notes {
                            ...Notes
                        }}
                    ... on Network {
                        notes {
                            ...Notes
                        }
                    }
                    ... on NetworkOwner {
                        notes {
                            ...Notes
                        }
                    }
                }
            }}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const values = {
        noteId: note.id,
        content: note.content
    }
    const schema = yup.object({
        content: yup.string().required("Content is required").max(300, "Content must be 300 or less characters")
    })
    const methods = useForm({values: values, resolver: yupResolver(schema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (returned) => {
                if(returned.modifyNote) {
                    toast.success("Note has been updated");
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"Edit Note"}
                   isInFlight={isInFlight}
                   methods={methods}
                   onSubmit={handleSubmit}

        >
            <HorizontalFormInput controlId={"content"}
                                 label={"Content"}
                                 as={"textarea"}
                                 rows={4} />
        </FormModal>
    )
}
export default EditNoteModal